import { HermesSkillsWorkbench } from "@/components/hermes/HermesSkillsWorkbench";

type HermesSkillsPanelProps = {
  accountId: string;
};

/** Hermes 技能管理面板（主从工作台入口）。 */
export function HermesSkillsPanel({ accountId }: HermesSkillsPanelProps) {
  return <HermesSkillsWorkbench accountId={accountId} />;
}
